export default "__VITE_ASSET__DYBX5oQE__"